export default __webpack_public_path__ + "static/media/vector-57.5232f448.webp";